import React, { Component } from 'react';
import firebase from '../Firebase';

class Show extends Component {

constructor(props) {
super(props);
this.state = {
board: {},
key: ''
};
}


componentDidMount() {
const ref = firebase.firestore().collection('test').doc(this.props.match.params.id);
ref.get().then((doc) => {
if (doc.exists) {
this.setState({
board: doc.data(),
key: doc.id,
isLoading: false
});
} else {
console.log("No such document!");
}
});
}

delete(id){
firebase.firestore().collection('test').doc(id).delete().then(() => {
console.log("Document successfully deleted!");
this.props.history.push("/")
}).catch((error) => {
console.error("Error removing document: ", error);
});
}

render() {

return (
<>
      <div class="card">
        
        <div className="button-row-2a">
          <div>
            <div className="card-heading">
              {!this.state.board.other ? <>{this.state.board.river}</> : null}

            </div>
            <div className="card-sub-heading">
              {this.state.board.section !=="Other" ? <>{this.state.board.section}</> : null}
            </div>
            <span><b>Observation: </b>{this.state.board.observation} </span><br />
            <span><b>Habitat Sampled: </b>{this.state.board.habitat}</span><br />
            <span><b>Air Temperature: </b>{this.state.board.airTemp}<sup>&deg;</sup></span>
          </div>
          {this.state.board.waterTemperature >="70" ? <div className="temperature-display-hot">
            {this.state.board.waterTemperature}<sup className="sup">&deg;</sup></div>
          : null}
          {this.state.board.waterTemperature >="63" && this.state.board.waterTemperature <="69"? <div
            className="temperature-display-warm">{this.state.board.waterTemperature}<sup className="sup">&deg;</sup>
        </div>
        : null}
        {this.state.board.waterTemperature >="53" && this.state.board.waterTemperature <="62"? <div
          className="temperature-display-good">{this.state.board.waterTemperature}<sup className="sup">&deg;</sup>
      </div>
      : null}
      {this.state.board.waterTemperature >="42" && this.state.board.waterTemperature <="52"? <div
        className="temperature-display-">{this.state.board.waterTemperature}<sup className="sup">&deg;</sup></div>
        : null}
    </div>
  </div>
</>
);
}
}

export default Show;